import { CrudList } from '../shared/CrudPage';
import { menuService } from '@kss/api';
import type { Menu, MenuCreate, MenuFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllMenus() {
  return (
    <CrudList<Menu, MenuCreate, MenuFilter>
      title="All menus" newLabel="New menu" service={menuService}
      idKey="menuId" labelKey="name" basePath="/panel/menus"
      columns={[
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'icon', title: 'Icon', render: (r) => r.icon || '—' },
        // Live API uses `route`; older mocks used `path` — fall back.
        { accessor: 'route', title: 'Route', sortable: true, filterable: true, render: (r) => r.route ?? r.path ?? '—' },
        // The raw parentId stays on the row (saved to the API) but the
        // grid cell displays the parent menu's name. NameCell shares a
        // single cached menuService.all() across all rows.
        { accessor: 'parentId', title: 'Parent', render: (r) => <NameCell kind="menu" id={r.parentId} /> },
        { accessor: 'sortOrder', title: 'Sort', sortable: true, textAlign: 'right', render: (r) => r.sortOrder ?? 0 },
        { accessor: 'isActive', title: 'Status', sortable: true, render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} /> },
      ]}
    />
  );
}
